export const gitCommit = '8eea4d39'
